import {
  Holder,
  Pic,
  Overlay,
  Caption,
  Text,
  Title,
  Mark,
  PicPivot,
  PicHolder
} from "./VisionariesSlide3.style"

import MarkIcon from "./mark.svg"

export default function VisionariesSlide3() {
  return (
    <Holder>
      <PicPivot>
        <PicHolder>
          <Pic src="/assets/images/about/image_3.jpg" />
          <Overlay>
            <Caption>
              <Title>
                BM3 – Working Drawing <br />
                Architect
              </Title>
              <Text>
                BM3 are a highly skilled group of architects and designers that
                pride themselves on being easy and fun to work with, providing a
                professional service from start to finish. BM3 has at the core
                of its practice philosophy, a consensual approach to
                regeneration, masterplanning and design that is reflected
                through all stages of its project work.
              </Text>
              <Mark src={MarkIcon}></Mark>
            </Caption>
          </Overlay>
        </PicHolder>
      </PicPivot>
    </Holder>
  )
}
